/**
 * Pure dispatcher deciding how a room renders in the 3D facility.
 * Encapsulates the unlock / ghost / marketing-tech-gate logic.
 * @param {object} roomDef - a FACILITY_ROOMS entry
 * @param {object} state - full game state
 * @returns {'greenhouse'|'industrial'|'construction'|'ghost'}
 */
export function selectBuildingKind(roomDef, state) {
  if (roomDef.ghost) return 'ghost';

  let unlocked;
  if (roomDef.type === 'marketing') {
    unlocked = state.unlockedTech?.includes('D4') || false;
  } else {
    unlocked = !roomDef.locked;
  }

  if (!unlocked) return 'construction';
  if (roomDef.type === 'greenhouse') return 'greenhouse';
  return 'industrial';
}
